import React from 'react'
import { Heading, Flex, Spinner } from '@theme-ui/components'
// import checkIfExternalLink from '../../helpers/checkIfExternalLink'
// import InternalLink from '../Links/InternalLink'
// import ExternalLink from '../Links/ExternalLink'
// import textSupressor from '../../helpers/textSupressor'
import LazyLoad from 'react-lazyload'
import backgroundStylesGradient from '../../helpers/backgroundStylesGradient'
import componentOptionsSelector from '../../helpers/componentOptionsSelector'
import TextBodySelector from '../General/TextBodySelector'
import LinkSelector from '../Links/LinkSelector'
import titleSelector from '../../helpers/titleSelector'
export default function AboutSectionV1({
  businessData,
  options,
  variantName,
  poweredImages,
  locations,
  locationIndex,
  allGeneral,
}) {
  const { desc, city } = businessData

  const storyId = options.storyId?.[locationIndex]

  // const {
  //   titles,
  //   subtitles,
  //   texts,
  //   ctaNames,
  //   ctaLinks,
  //   containerStyles,
  //   backgroundImages,
  //   restrictCharacters,
  //   backgroundGradient,
  // } = options

  const {
    titles,
    subtitles,
    texts,
    textType,
    ctaLinks,
    ctaNames,
    images,
    restrictCharacters,
    backgroundImages,
    backgroundGradient,
    containerStyles,
  } = componentOptionsSelector(options, locationIndex, storyId, allGeneral)

  const isMultiLocationSite = locations.length > 1
  // chooses variantName
  const variant = variantName ? variantName : 'contentSectionV1'

  // creates container and parse string styles from config file to object
  const styles = containerStyles ? JSON.parse(containerStyles) : {}

  // this is needed to when using stories as hardcoded uses backgroundImages option where stories uses images property
  const imageSelector = backgroundImages
    ? backgroundImages
    : images
    ? images
    : ''

  // build backgroundImageStyle object with dyanmic gradent options with poweredImagesSelector
  const backgroundStyles =
    backgroundImages || (images && images?.length !== 0)
      ? backgroundStylesGradient(
          Array.isArray(imageSelector) ? imageSelector[0] : imageSelector,
          backgroundGradient,
          poweredImages,
          locationIndex
        )
      : ''

  // const backgroundStyles = backgroundImages
  //   ? backgroundStylesGradient(
  //       backgroundImages[locationIndex],
  //       backgroundGradient,
  //       poweredImages,
  //       locationIndex
  //     )
  //   : ''

  // functions

  // const renderText = (text) => {
  //   switch (text) {
  //     case 'none':
  //       return '';
  //     case 'default':
  //       return (
  //         <Text as='p' variant={`${variant}.text`} className='text'>
  //           {textSupressor(desc, restrictCharacters)}
  //         </Text>
  //       );
  //     case '':
  //       return (
  //         <Text as='p' variant={`${variant}.text`} className='text'>
  //           {textSupressor(desc, restrictCharacters)}
  //         </Text>
  //       );
  //     case text:
  //       return (
  //         <Text as='p' variant={`${variant}.text`} className='text'>
  //           {textSupressor(text, restrictCharacters)}
  //         </Text>
  //       );
  //     default:
  //       break;
  //   }
  // };

  // const renderTitle = (title) => {
  //   switch (title) {
  //     case 'none':
  //       return '';
  //     case '':
  //       return '';
  //     case 'default':
  //       return (
  //         <Heading as='h2' variant={`${variant}.title`} className='title'>
  //           {name}
  //         </Heading>
  //       );
  //     case title:
  //       return (
  //         <Heading as='h2' variant={`${variant}.title`} className='title'>
  //           {title}
  //         </Heading>
  //       );
  //     default:
  //       break;
  //   }
  // };

  return (
    <LazyLoad
      placeholder={
        <Flex sx={{ justifyContent: 'center', alignItems: 'center' }}>
          <Spinner />
        </Flex>
      }
    >
      <Flex
        variant={`${variant}.container`}
        className='container'
        sx={{
          backgroundImage: backgroundStyles,
          ...styles,
        }}
      >
        <Flex variant={`${variant}.section`} className='section'>
          {subtitles ? (
            <Heading variant={`${variant}.subtitle`} className='subtitle'>
              {subtitles}
            </Heading>
          ) : (
            ''
          )}

          {/* {!titles ? '' : renderTitle(titles[locationIndex])} */}
          {titles && titleSelector(titles) ? (
            <Heading as='h2' variant={`${variant}.title`} className='title'>
              {titleSelector(titles)}
            </Heading>
          ) : (
            ''
          )}

          {/* {!texts ? (
            <Text as='p' variant={`${variant}.text`} className='text'>
              {textSupressor(desc, restrictCharacters)}
            </Text>
          ) : (
            renderText(texts[locationIndex])
          )} */}

          {texts ? (
            <TextBodySelector
              variantName={`${variantName}`}
              texts={texts}
              textType={textType}
              restrictCharacters={restrictCharacters}
              desc={desc}
            />
          ) : (
            ''
          )}

          {ctaLinks && ctaNames ? (
            <LinkSelector
              variant={`${variantName}`}
              ctaName={ctaNames}
              ctaLink={ctaLinks}
              isMultiLocationSite={isMultiLocationSite}
              city={city}
            />
          ) : (
            ''
          )}

          {/* {ctaNames && ctaLinks ? (
            checkIfExternalLink(ctaLinks[locationIndex]) ? (
              <ExternalLink
                variant={variant}
                ctaName={ctaNames[locationIndex]}
                ctaLink={ctaLinks[locationIndex]}
                isMultiLocationSite={isMultiLocationSite}
                city={city}
              />
            ) : (
              <InternalLink
                variant={variant}
                ctaName={ctaNames[locationIndex]}
                ctaLink={ctaLinks[locationIndex]}
                isMultiLocationSite={isMultiLocationSite}
                city={city}
              />
            )
          ) : (
            ''
          )} */}
        </Flex>
      </Flex>
    </LazyLoad>
  )
}
